import { SelectChangeEvent } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { filteredDataGraphic } from 'v2/resources/utils/filteredDataGraphic';
import { useQueryBiometricsNurseries } from 'v2/resources/hooks/services/useGraphics';
import {
  useAppDispatch,
  useAppSelector,
} from 'v2/resources/hooks/useAppSelector';
import { IGraphicInfo } from 'v2/resources/types/graphics';
import { setGraphicBiometricsNurseries } from 'v2/store/dataChat/slice';

const useBiometricsNurseries = () => {
  const dispatch = useAppDispatch();
  const { selectedCycle } = useAppSelector((state) => state.selectedCycle);

  const [selectedNurseries, setSelectedNurseries] = useState<string>('default');
  const [selectedParameters, setSelectedParameters] = useState<IGraphicInfo[]>(
    []
  );

  const { data: dataBiometricsnNurseries } = useQueryBiometricsNurseries(
    selectedCycle?.id
  );

  const handleChangeParameters = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;
    if (String(value).includes('default')) {
      return;
    }
    setSelectedNurseries(value as string);
  };

  const handleLoadData = useCallback(() => {
    if (!dataBiometricsnNurseries) return;

    if (dataBiometricsnNurseries.labels?.length === 0) {
      setSelectedNurseries('default');
    }
    setSelectedNurseries(dataBiometricsnNurseries.labels[0] ?? 'default');
    dispatch(setGraphicBiometricsNurseries(dataBiometricsnNurseries));
  }, [dataBiometricsnNurseries]);

  const optionsnNurseries = useMemo(() => {
    const defaultOption = [
      {
        id: 1,
        label: 'Viveiros:',
        value: 'default',
      },
      {
        id: 2,
        label: 'Viveiros:',
        value: 'default2',
      },
    ];

    if (!dataBiometricsnNurseries) return defaultOption;

    if (dataBiometricsnNurseries.labels?.length === 0) return defaultOption;

    return [
      ...[defaultOption[0]],
      ...dataBiometricsnNurseries?.labels.map((label, index) => ({
        id: index + 1,
        label: label,
        value: label,
      })),
    ];
  }, [dataBiometricsnNurseries]);

  const optionsParameters = useMemo(() => {
    if (!dataBiometricsnNurseries) return [];

    const result = filteredDataGraphic(
      dataBiometricsnNurseries,
      selectedNurseries
    );

    setSelectedParameters(result);
    return result;
  }, [dataBiometricsnNurseries, selectedNurseries]);

  useEffect(() => {
    handleLoadData();
  }, [handleLoadData]);

  return {
    optionsnNurseries,
    selectedNurseries,
    optionsParameters,
    selectedParameters,

    handleChangeParameters,
    setSelectedParameters,
  };
};
export default useBiometricsNurseries;
